import React, { useState } from 'react'
import IconVerifiedCheckMark from '../../../components/IconVerifiedCheckMark'
import Tag from '@/components/atoms/Tag/Tag'
import { isNonEmptyString } from '../../../utils/checks'
import getCenterAddressForCard from '../../../domain/center/useCases/getCenterAddressForCard'
import { Center } from '@/types/models'

interface CenterCardHeaderProps {
  title: string
  providerType: string | string[]
  isAd: boolean
  hasCertifications: boolean
  isPremiumCenter: boolean
  center: Center
}

const CenterCardHeader: React.FC<CenterCardHeaderProps> = ({
  title,
  providerType,
  isAd,
  hasCertifications,
  isPremiumCenter,
  center
}) => {
  const providerTypePosition = isPremiumCenter
    ? 'md:left-8 md:top-8'
    : 'md:left-4 md:top-4'

  return (
    <div>
      <div
        className={`absolute left-4 top-4 flex gap-2 ${providerTypePosition}`}
      >
        {Array.isArray(providerType)
          ? providerType.map(
              (provider) =>
                provider !== 'none' && (
                  <Tag
                    backgroundColor="bg-white/[.85]"
                    className="capitalize text-black backdrop-blur-sm"
                    key={provider}
                  >
                    {provider}
                  </Tag>
                )
            )
          : isNonEmptyString(providerType) &&
            providerType !== 'none' && (
              <Tag
                backgroundColor="bg-white/[.85]"
                className="capitalize text-black backdrop-blur-sm"
              >
                {providerType}
              </Tag>
            )}
        {isAd && (
          <Tag
            backgroundColor="bg-stone-800/75"
            className="rounded-md stroke-white/20 stroke-[1px] text-white outline outline-1 outline-white/20 backdrop-blur-sm"
          >
            Ad
          </Tag>
        )}
      </div>
      <div className="flex flex-col gap-1.5">
        <div className="line-clamp-1 text-sm text-gray-800">
          {getCenterAddressForCard(center)}
        </div>
        <div className="inline-flex items-center">
          <h3 className="inline font-FieldsVariable text-xl font-medium leading-7 tracking-[0.3px] text-gray-1100 hover:underline">
            {title}
            {hasCertifications && (
              <span className="relative top-px ml-1 inline-block text-blue-400">
                <IconVerifiedCheckMark size="sm" />
              </span>
            )}
          </h3>
        </div>
      </div>
    </div>
  )
}

export default CenterCardHeader
